// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.support-img{width:100%;height:auto}.support-img-max{width:140%;height:auto}.support-img-min{width:70%;height:auto}`, "",{"version":3,"sources":["webpack://./src/components/Support/infolink/support.scss"],"names":[],"mappings":"AAAA,aACI,UAAA,CACA,WAAA,CAGJ,iBACI,UAAA,CACA,WAAA,CAGJ,iBACI,SAAA,CACA,WAAA","sourcesContent":[".support-img {\n    width: 100%;\n    height: auto;\n}\n\n.support-img-max {\n    width: 140%;\n    height: auto;\n}\n\n.support-img-min {\n    width: 70%;\n    height: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"support-img": `support-img`,
	"support-img-max": `support-img-max`,
	"support-img-min": `support-img-min`
};
export default ___CSS_LOADER_EXPORT___;
